// List of supported locales
export const locales = ["en-CA", "fr-CA"]

/**
 * Get the preferred locale from browser
 */
export function getPreferredLocale(): string {
  // First, check if there's a culture parameter in the URL
  if (typeof window !== "undefined") {
    const url = new URL(window.location.href)
    const cultureParam = url.searchParams.get("culture")
    if (cultureParam && locales.includes(cultureParam)) {
      console.log("Using culture parameter:", cultureParam)
      return cultureParam
    }

    // Then, check localStorage for a preferred locale
    const storedLocale = localStorage.getItem("APP_LOCALE")
    if (storedLocale && locales.includes(storedLocale)) {
      console.log("Using stored locale:", storedLocale)
      return storedLocale
    }

    // Otherwise, use the browser's language
    const browserLang = navigator.language
    if (browserLang.startsWith("fr")) return "fr-CA"
  }

  // Default to English
  return "en-CA"
}

/**
 * Set the locale in localStorage
 */
export function setLocaleInStorage(locale: string): void {
  if (typeof window !== "undefined") {
    localStorage.setItem("APP_LOCALE", locale)
  }
}
